import _, { reject } from 'lodash';
import ah from '../utils/ajax-helper';
export var getPredictionGates = function getPredictionGates(contextRoot, gateId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/gate/").concat(gateId, "/prediction")).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getPredictionGatesItt = function getPredictionGatesItt(contextRoot, startGateId, destinationGateId) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      start: startGateId,
      destination: destinationGateId
    };
    ah.get("".concat(contextRoot, "/gates/itt/prediction"), requestParameters).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getPredictionTerminals = function getPredictionTerminals(contextRoot, terminalId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/terminal/").concat(terminalId, "/prediction")).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // Prediction 24h gate estVisitDuration

export var getGatePrediction = function getGatePrediction(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/gate/prediction"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // Prediction 24h terminal estTrailerLineQty

export var getTerminalPrediction = function getTerminalPrediction(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/terminal/prediction"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};

var handleDateRange = function handleDateRange(date) {
  return date.split(' ')[0] + ' 00:00:00';
};

var addStartTime = function addStartTime(date) {
  return date.split(' ')[0] + ' 00:00:00';
};

var addEndTime = function addEndTime(date) {
  return date.split(' ')[0] + ' 23:59:59';
}; // traffic terminal-line by day


export var getTrafficTerminalLineByDay = function getTrafficTerminalLineByDay(contextRoot, noProgress, dateRange) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      terminalId: ''
    };
    ah.get("".concat(contextRoot, "/traffic/terminal-line/by/day"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // traffic terminal-line

export var getTrafficTerminalLine = function getTrafficTerminalLine(contextRoot, noProgress, dateRange) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      terminalId: ''
    };
    ah.get("".concat(contextRoot, "/traffic/terminal-line"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // traffic zone-visit by day 

export var getTrafficZoneVisitByDay = function getTrafficZoneVisitByDay(contextRoot, noProgress, dateRange) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to)
    };
    ah.get("".concat(contextRoot, "/traffic/zone-visit/by/day"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // traffic zone-visit

export var getTrafficZoneVisit = function getTrafficZoneVisit(contextRoot, noProgress, dateRange) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to)
    };
    ah.get("".concat(contextRoot, "/traffic/zone-visit"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // traffic road-section by day

export var getTrafficRoadSectionByDay = function getTrafficRoadSectionByDay(contextRoot, noProgress, dateRange) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to)
    };
    ah.get("".concat(contextRoot, "/traffic/road-section/by/day"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // traffic road-section pred by day

export var getTrafficRoadSectionPredByDay = function getTrafficRoadSectionPredByDay(contextRoot, noProgress, dateRange) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: dateRange.from + ':00',
      end: dateRange.to + ':00'
    };
    ah.get("".concat(contextRoot, "/traffic/road-section/pred/by/day"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得交領櫃台所有時間的交通統計資訊

export var getTrafficTerminalLineAllTime = function getTrafficTerminalLineAllTime(contextRoot, terminalId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/traffic/terminal-line/").concat(terminalId, "/all-time")).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得查驗站所有時間的交通統計資訊 /traffic/ zone-visit/{gateId}/all-time

export var getTrafficZoneVisitAllTime = function getTrafficZoneVisitAllTime(contextRoot, gateId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/traffic/zone-visit/").concat(gateId, "/all-time")).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};